import { MapPin } from "lucide-react";
import { Placeholder } from "./Placeholder";
import { useReveal } from "../hooks/useReveal";
import { IMG } from "../lib/images";
import { useLanguage } from "../lib/LanguageContext";

export const Location = () => {
  const ref = useReveal();
  const { t } = useLanguage();
  const distances = [
    { label: t("loc_d_karavostasi"), value: t("loc_v_900m") },
    { label: t("loc_d_taverns"), value: t("loc_v_10min") },
    { label: t("loc_d_kalou"), value: t("loc_v_15min") },
    { label: t("loc_d_voulisma"), value: t("loc_v_4min") },
    { label: t("loc_d_ammoudara"), value: t("loc_v_8km") },
    { label: t("loc_d_agios"), value: t("loc_v_10km") },
    { label: t("loc_d_lake"), value: t("loc_v_10km") },
    { label: t("loc_d_panagia"), value: t("loc_v_10km") },
    { label: t("loc_d_airport"), value: t("loc_v_55km") },
  ];
  return (
    <section
      id="location"
      data-testid="location-section"
      className="py-24 md:py-36 bg-[#0a192f] text-[#faf9f6] relative overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div ref={ref} className="reveal relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          <div className="md:col-span-5">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#c9d8c5] mb-6">
              {t("loc_eyebrow")}
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-tight leading-[1.02]">
              {t("loc_title_a")}{" "}
              <em className="italic text-[#7fb2c1]">{t("loc_title_b")}</em>.
            </h2>
            <p className="mt-8 text-white/70 font-light leading-relaxed text-base md:text-lg max-w-md">
              {t("loc_intro")}
            </p>

            <div className="mt-12">
              <Placeholder
                src={IMG.aerialProperty}
                alt="Aerial view of Athina Villas and Cretan coastline"
                label={t("loc_map_label")}
                caption={t("loc_map_caption")}
                className="h-[260px] md:h-[320px]"
                testId="map-placeholder"
              />
              <div className="mt-4 flex items-center gap-2 text-white/60 text-xs">
                <MapPin className="h-4 w-4" strokeWidth={1.4} />
                {t("loc_address")}
              </div>
            </div>
          </div>

          <div className="md:col-span-7">
            <ul className="divide-y divide-white/10 border-t border-b border-white/10">
              {distances.map((d, i) => (
                <li
                  key={i}
                  data-testid={`distance-${i}`}
                  className="flex items-baseline justify-between py-5 md:py-6 group"
                >
                  <span className="font-serif text-2xl md:text-3xl font-light text-white">
                    {d.label}
                  </span>
                  <span className="flex items-center gap-4">
                    <span className="hidden md:block flex-1 w-32 lg:w-48 border-t border-dotted border-white/30 group-hover:border-[#7fb2c1] transition-colors" />
                    <span className="text-[#c9d8c5] text-[11px] uppercase tracking-[0.22em]">
                      {d.value}
                    </span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
